import React, { useRef, useState, useEffect } from 'react';
import classnames from 'classnames/bind';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

import { withSnapPoint } from '@components/snapping-slider';
import RichText from '@components/rich-text';
import DragIcon from '@icons/drag';
import { colors } from '@utils/color';
import css from './progress.module.scss';

const styles = classnames.bind(css);

const ProgressSlide = ({ slides, active, slideRef }) => {
    const [value, setValue] = useState(0);

    // Autoplay functionality:
    const timer = useRef(-1);
    useEffect(() => {
        timer.current = setInterval(() => {
            if (active) {
                const currentSlideIsLast = value === slides.length - 1;
                const nextValue = currentSlideIsLast ? 0 : value + 1;
                setValue(nextValue);
            }
        }, 4000);

        // Remove the timer on Unmount
        return () => {
            clearInterval(timer.current);
        };
    });

    return (
        <div ref={slideRef} className={styles('progress-slide')}>
            <>
                {slides.map((slide, index) => (
                    <div
                        key={`progress-image-${index}`}
                        style={{ backgroundImage: `url(${slide.image})` }}
                        className={styles('progress-slide__image', {
                            'progress-slide__image--active': index === value,
                        })}
                    />
                ))}
            </>

            <div className={styles('progress-slide__mask')} />
            <div className={styles('progress-slide__slider-container')}>
                <div className={styles('progress-slide__slider')}>
                    <Slider
                        min={0}
                        max={slides.length - 1}
                        dots={true}
                        value={value}
                        onChange={setValue}
                        aria-hidden
                        dotStyle={{
                            height: 10,
                            width: 2,
                            right: -4,
                            bottom: -7,
                            border: 'none',
                            background: colors.offBlack,
                            borderRadius: 4,
                        }}
                        activeDotStyle={{
                            background: colors.offBlack,
                        }}
                        railStyle={{
                            borderRadius: 0,
                            backgroundColor: colors.offBlack,
                            left: -4,
                            height: 2,
                            width: 'calc(100% + 2px)',
                        }}
                        trackStyle={{
                            borderRadius: 0,
                            height: 2,
                            backgroundColor: colors.offBlack,
                        }}
                        handle={(props) => {
                            return (
                                <div style={{ marginLeft: props.offset + '%' }}>
                                    <div tabIndex={0} className={styles('progress-slide__thumb')}>
                                        <DragIcon className={styles('progress-slide__thumb__icon')} />
                                    </div>
                                </div>
                            );
                        }}
                    />
                    <div
                        aria-label="Click label to show associated image"
                        className={styles('progress-slide__label-container')}
                    >
                        {slides.map((slide, index) => (
                            <RichText
                                tabIndex={0}
                                key={`progress-label-${index}`}
                                aria-label={`Click to show ${slide.label} image`}
                                className={styles('progress-slide__label')}
                                onClick={() => setValue(index)}
                            >
                                {slide.label}
                            </RichText>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withSnapPoint(ProgressSlide);
